import AuthorizationStore from '../../common_components/authorization/AuthorizationStore';
import {
  EDIT_FEEDBACK_CHAIN_ALLOWED_ROLES,
} from '../../common_components/authorization/allowed_roles';

export default class Authorization extends AuthorizationStore {
  constructor(rootStore) {
    super(rootStore);
  }


  canEditComment(comment) {
    return this.rootStore.user.id == comment.creator.id;
  }

  canRateFeedback(feedbackChain) {
    return this.rootStore.user.id == feedbackChain.creator.id;
  }

  canEditFeedbackContents(feedbackChain) {
    return this.rootStore.user.id == feedbackChain.creator.id;
  }


  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CONTROL PANEL AUTHORIZATION
  canEditFeedback(feedbackChain) {
    if (this._canEditFeedback == undefined) {
      this._canEditFeedback = this.rootStore.currentStartup.id == this.rootStore.startupId
                && this.authorizationApi(EDIT_FEEDBACK_CHAIN_ALLOWED_ROLES)(this.rootStore);
    }
    return this._canEditFeedback;
  }

  canFetchValuePropositions() {
    return this.canEditFeedback();
  }

  canCreateTask() {
    return this.canFetchValuePropositions();
  }

  canFetchTasks() {
    return this.canFetchValuePropositions();
  }

  canSeeTasks() {
    if (this._canSeeTasks == undefined) {
      this._canSeeTasks = this.rootStore.currentStartup.id == this.rootStore.startupId
                && this.rootStore.currentUserBelongsToStartup();
    }
    return this._canSeeTasks;
  }

  canSeeValuePropositions() {
    return this.canSeeTasks();
  }
  // end CONTROL PANEL AUTHORIZATION
  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // STATISTICS AUTHORIZATION
  canSeeAnalytics() {
    if (this._canSeeAnalytics == undefined) {
      this._canSeeAnalytics = this.rootStore.currentStartup.id == this.rootStore.startupId
                && this.rootStore.currentUserBelongsToStartup();
    }
    return this._canSeeAnalytics;
  }
  // end STATISTICS AUTHORIZATIONS
  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
